import actionTypes from 'dashboard/actions/announcements/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements/items.js